import React from 'react';
import { Link } from 'react-router-dom';

const MobileCTA = () => {
  return (
    <div 
      className="mobile-cta-bar"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'var(--white)',
        borderTop: '1px solid #ddd',
        padding: '1rem',
        display: 'none',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
      }}
    >
      <div style={{ display: 'flex', gap: '1rem' }}>
        <a 
          href="tel:+6591234567" 
          className="btn btn-secondary" 
          style={{ flex: 1, textAlign: 'center', textDecoration: 'none' }}
        >
          📞 Call Now
        </a>
        <Link 
          to="/wholesale" 
          className="btn btn-primary" 
          style={{ flex: 1, textAlign: 'center', textDecoration: 'none' }}
        >
          💼 Request Quote
        </Link>
      </div>
      
      <style jsx>{`
        @media (max-width: 768px) {
          .mobile-cta-bar {
            display: block !important;
          }
          body {
            padding-bottom: 80px;
          }
        }
      `}</style>
    </div>
  );
};

export default MobileCTA;